import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { getDocumentNumber, mongoId } from '../../../../@core/common/global';
import { ApiService } from '../../../../@core/service/api.service';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { CompilationTypeData } from '../../../../@models/erp/compilationData';
import { AbstractItemType } from '../../abstractItem';
import { DocumentSelectComponent } from './document-select.component';

@Component({
  selector: 'ngx-document-combined-shipment-selector',
  templateUrl: '../document-select/document-select.component.html',
  styleUrls: ['../document-select/document-select.component.scss'],
})
export class DocumentCombinedShipmentSelectorComponent extends DocumentSelectComponent implements OnInit {

  constructor(private datePipe: DatePipe, public api: ApiService, public data: SharedDataService) {
    super(data);

  }

  preFilter(items: CompilationModel[]): CompilationModel[] {
    return items.filter(f => !f.draft && f.type === CompilationTypeData.get('CS').id);
  }

  style = { 'width': '800px' } // TODO: replace popups with dialogs

  async ngOnInit() {
    this.initialItems = await this.api.getCombinedShipments();
    // console.log('cs reloaded', this.initialItems);
    this.latestVersionItems = [...this.initialItems];
  }

  columns = [
    { id: 'code', title: 'Document number', search: '' },
    { id: 'recipient', title: 'Recipient', search: '' },
    { id: 'exwJapanDate', title: 'EXW date', search: '' },
    { id: 'arrivingVieDate', title: 'ETA AT date', search: '' },
    { id: 'placeOfLoadingRecipient', title: 'Place of loading', search: '' },
    { id: 'meansOfTransport', title: 'Mean of transport', search: '' },
    // { id: 'internal', title: 'Internal', search: '' },
    { id: 'status', title: 'Status', search: '' },
  ]

  getText(col: string, item: CompilationModel) {
    if (!item) return '';
    switch (col) {
      case 'code': return getDocumentNumber(item);
      case 'recipient':
        const recipient = this.data.businesses.find(b => mongoId(b) === mongoId(item.recipient))
        return (recipient && recipient.name) || '';
      case 'arrivingVieDate':
      case 'exwJapanDate': return this.datePipe.transform(item[col], 'yyyy-MM-dd')
      case 'placeOfLoadingRecipient':
        const business = this.data.businesses.find(b => mongoId(b) === mongoId(item.placeOfLoadingRecipient))
        return (business && business.name) || '';
      case 'meansOfTransport': return item.meansOfTransport;
      case 'status': return ['', 'Planned', 'En Route', 'Completed'][item.transportRun.transportStatus];
      default: return item[col];
    }
  }
}

